import { CHARTS_2_URL } from 'features/charts-v2/paths'
import { CHARTS_URL } from 'features/charts/paths'
import { DASHBOARD_URL } from 'features/dashboard/paths'
import { FEEDBACK_URL } from 'features/feedback/paths'
import { KEYWORDS_URL } from 'features/keywords/paths'
import { PRODUCT_WATCH_URL } from 'features/product-watch/paths'
import { DASHBOARDS_2_URL } from 'src/features/dashboards-v2/paths'

// -- Cross-cutting route constants ------------------------------------------

export const COMPARATIVE_PART = 'comparative'

export const SCREEN_STATE_PAGES = new Set([
  CHARTS_URL,
  CHARTS_2_URL,
  FEEDBACK_URL,
  KEYWORDS_URL,
  PRODUCT_WATCH_URL,
])

export const projectPath = (id?: string): string =>
  id ? `/project/${id}` : '/project/:id'

export const projectSharePath = (id?: string, token?: string): string =>
  id && token ? `/project/${id}/shared/${token}` : '/project/:id/shared/:token'

// -- Path utilities ---------------------------------------------------------

export const getScreenIdFromPath = (pathname: string): string | null => {
  const parts = pathname.split('/').filter((l) => l.length)
  for (let i = 0; i < parts.length - 1; i++) {
    if (SCREEN_STATE_PAGES.has(parts[i]!)) {
      return parts[i + 1]!
    }
  }
  return null
}

export const buildPageUrl = (pathname: string, hash: string): string => {
  const parts = pathname.split('/').filter((l) => l.length)
  for (let i = parts.length - 1; i >= 0; i--) {
    if (SCREEN_STATE_PAGES.has(parts[i]!)) {
      const baseParts = parts.slice(0, i + 1)
      return '/' + [...baseParts, hash].join('/')
    }
  }
  return pathname.replace(/\/$/, '') + '/' + hash
}

export const buildProjectPageUrl = (
  projectId: string,
  page: string,
  hash: string,
): string => `/project/${projectId}/${page}/${hash}`

export const buildProjectCustomDashboardPath = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARD_URL}/${dashboardId}`

export const buildProjectCustomDashboardEditPath = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARD_URL}/${dashboardId}/edit`

export const buildProjectCustomDashboardNewPath = (projectId: string): string =>
  `/project/${projectId}/${DASHBOARD_URL}/new`

export const buildProjectCustomDashboardPathV2 = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARDS_2_URL}/${dashboardId}`

export const buildProjectCustomDashboardEditPathV2 = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARDS_2_URL}/${dashboardId}/edit`

export const buildProjectCustomDashboardNewPathV2 = (
  projectId: string,
): string => `/project/${projectId}/${DASHBOARDS_2_URL}/new`

export const buildDbSearchUrl = (pathname: string, search: string): string => {
  const pathHash = getScreenIdFromPath(pathname)
  if (pathHash) {
    const params = new URLSearchParams(search)
    params.set('filters', pathHash)
    return '?' + params.toString()
  }
  return search
}

export const isScreenStatePage = (pathname: string): boolean => {
  const parts = pathname.split('/').filter((l) => l.length)
  if (parts.length >= 3 && parts[0] === 'project') {
    return SCREEN_STATE_PAGES.has(parts[2]!)
  }
  return parts.some((part) => SCREEN_STATE_PAGES.has(part))
}
